import axios, { AxiosResponse } from 'axios';
import { IPortfolio, IPortfolioWithVessels } from './portfolioTypes';
import { authApiV2 } from '../../axiosWrapper';

export const addPortfolioApi = async (portfolio: IPortfolioWithVessels, teamId: number | null, subscriptionId: number): Promise<number> => {
    try {
        const endpoint = `/portfolios/add-portfolio`;
        const response: AxiosResponse<any> = await authApiV2.post(endpoint, { name: portfolio.name, teamId: teamId, subscriptionId: subscriptionId, portfolioVesselsImoList: portfolio.portfolioVesselsImoList });
        return response.data;
    }
    catch (error) {
        handleAxiosError(error, 'Failed to add portfolio');
        throw error;
    }
};

export const updatePortfolioApi = async (portfolio: IPortfolioWithVessels, teamId: number | null) => {
    try {
        const endpoint = `/portfolios/update-portfolio`;
        await authApiV2.put(endpoint, { id: portfolio.id, name: portfolio.name, teamId: teamId, portfolioVesselsImoList: portfolio.portfolioVesselsImoList });
    }
    catch (error) {
        handleAxiosError(error, `Failed to update portfolio with id ${portfolio.id}`);
    }
};

export const getPortfolioByIdApi = async (id: number): Promise<IPortfolioWithVessels> => {
    try {
        const endpoint = `/portfolio`;
        const response: AxiosResponse<any> = await authApiV2.get(endpoint, { params: { id } });
        return response.data;
    }
    catch (error) {
        handleAxiosError(error, 'Failed to get portfolio with MSI vessels by id');
        throw error;
    }
};

export const getPortfoliosApi = async (teamId: number, subscriptionId: number): Promise<IPortfolio[]> => {
    try {
        const endpoint = `/portfolios`;
        const response: AxiosResponse<any> = await authApiV2.get(endpoint, { params: { teamId, subscriptionId } });
        return response.data
    }
    catch (error) {
        handleAxiosError(error, 'Failed to get portfolios');
        throw error;
    }
};

export const deletePortfolioApi = async (id: number) => {
    // Implement API call to delete a portfolio
    try {
        await authApiV2.delete(`/portfolios/${id}/delete`);
        // No need to return anything if API doesn't return a body (204 No Content)
    } catch (error) {
        handleAxiosError(error, `Failed to delete portfolio with id ${id}`);
    }
};


// apiHelper.ts
export const handleAxiosError = (error: unknown, defaultMessage: string) => {
    if (axios.isAxiosError(error)) {
        const errorMessage = error.response?.data?.message || error.response?.statusText || error.message;
        throw new Error(errorMessage || defaultMessage || 'An Axios error occurred');
    }
    throw new Error(defaultMessage);
};